export default "__VITE_ASSET__e542f8a3__"